import { apiHandlerWithError } from 'api/apiHandler';
import { addQueryParams } from 'api';

export default async function getCapacityReports(start_date, end_date) {
  return await apiHandlerWithError(addQueryParams(`capacity-reports`, { start_date: start_date, end_date: end_date }));
}
